import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { BASE_URL } from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

export default class AgentContractClient {
  static baseUrl = BASE_URL;

  static getAgentContract(token, market) {
    return axios
      .get(this.url(market), getHeaders(token))
      .then((response) => response.data.result.agentContract)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static uploadAgentContract(token, nsc, market, request) {
    return axios
      .put(this.urlPut(nsc, market), request, getHeaders(token))
      .then((response) => response.status)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static updateContractEmails(token, request) {
    const url = `${this.baseUrl}/agent/agent-customer-contract/emails`;
    return axios
      .post(url, request, getHeaders(token))
      .then(() => Promise.resolve())
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static url = (market) =>
    `${this.baseUrl}/agent/agent-customer-contract?market=${market}`;

  static urlPut = (nsc, market) =>
    `${this.baseUrl}/agent/agent-customer-contract?nsc=${nsc}&market=${market}`;
}
